import DeleteIcon from '@mui/icons-material/Delete'
import ImportExportIcon from '@mui/icons-material/ImportExport'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import { colors } from '@global/constants/colors'
import { FileDropZone } from '../file-drop-zone'
import * as css from '../styles'
import { t } from '@lingui/core/macro'

interface StartPhaseProps {
  expectedMimeTypes: string[]
  fileName: string
  handleDrop: (files: File[]) => void
  onDeleteSelectedFile: () => void
  onSelectFileToUpload: () => void
}

export const StartPhase = ({
  expectedMimeTypes,
  fileName,
  handleDrop,
  onDeleteSelectedFile,
  onSelectFileToUpload,
}: StartPhaseProps) => (
  <css.DialogContentStyled data-testid="dialog-window">
    <FileDropZone expectedMimeTypes={expectedMimeTypes} handleDrop={handleDrop}>
      <ImportExportIcon style={{ ...css.iconStyle, color: colors.gray.main }} />
      <Typography variant="h4">{t`Drag & drop file here`}</Typography>
      <Typography variant="caption">
        File must be UTF-8 encoded and fewer than 50,000 rows.
      </Typography>
      <Typography variant="body1">
        <i>OR</i>
      </Typography>
      <Button
        name="browse-files"
        color="secondary"
        variant="contained"
        onClick={onSelectFileToUpload}
        data-testid="browse-files-button"
      >
        {t`Browse files`}
      </Button>
    </FileDropZone>
    {fileName && (
      <css.SelectedFilesContainer data-testid="selected-file">
        <css.FileIcon />
        <css.FileDescription variant="body2" component="span">
          {fileName}
        </css.FileDescription>
        <IconButton size="medium" onClick={onDeleteSelectedFile} data-testid="delete-button">
          <DeleteIcon />
        </IconButton>
      </css.SelectedFilesContainer>
    )}
  </css.DialogContentStyled>
)
